import { render, staticRenderFns } from "./edit-activity-basic.vue?vue&type=template&id=6c2524fc&scoped=true&"
import script from "./edit-activity-basic.vue?vue&type=script&lang=js&"
export * from "./edit-activity-basic.vue?vue&type=script&lang=js&"
import style0 from "./edit-activity-basic.vue?vue&type=style&index=0&id=6c2524fc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2524fc",
  null
  
)

export default component.exports